function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/observer/bubblingeventinfo
 */
import EventInfo from '@ckeditor/ckeditor5-utils/src/eventinfo';
/**
 * The event object passed to bubbling event callbacks. It is used to provide information about the event as well as a tool to
 * manipulate it.
 *
 * @extends module:utils/eventinfo~EventInfo
 */

var BubblingEventInfo = /*#__PURE__*/function (_EventInfo) {
  _inherits(BubblingEventInfo, _EventInfo);

  var _super = _createSuper(BubblingEventInfo);

  /**
   * @param {Object} source The emitter.
   * @param {String} name The event name.
   * @param {module:engine/view/range~Range} startRange The view range that the bubbling should start from.
   */
  function BubblingEventInfo(source, name, startRange) {
    var _this;

    _classCallCheck(this, BubblingEventInfo);

    _this = _super.call(this, source, name);
    /**
     * The view range that the bubbling should start from.
     *
     * @readonly
     * @member {module:engine/view/range~Range}
     */

    _this.startRange = startRange;
    /**
     * The current event phase.
     *
     * @protected
     * @member {'none'|'capturing'|'atTarget'|'bubbling'}
     */

    _this._eventPhase = 'none';
    /**
     * The current bubbling target.
     *
     * @protected
     * @member {module:engine/view/document~Document|module:engine/view/node~Node|null}
     */

    _this._currentTarget = null;
    return _this;
  }
  /**
   * The current event phase.
   *
   * @readonly
   * @member {'none'|'capturing'|'atTarget'|'bubbling'}
   */


  _createClass(BubblingEventInfo, [{
    key: "eventPhase",
    get: function get() {
      return this._eventPhase;
    }
    /**
     * The current bubbling target.
     *
     * @readonly
     * @member {module:engine/view/document~Document|module:engine/view/node~Node|null}
     */

  }, {
    key: "currentTarget",
    get: function get() {
      return this._currentTarget;
    }
  }]);

  return BubblingEventInfo;
}(EventInfo);

export { BubblingEventInfo as default };